'use client';

import classNames from 'classnames';

import { PropsWithClassname } from '@/app/types';
import Button, { ButtonHTMLTag, ButtonStyle } from '@/app/components/Button/Button';
import { Routes } from '@/app/enums';
import { useTranslation } from 'react-i18next';

interface NewProjectCTABannerProps extends PropsWithClassname {}

const NewProjectCTABanner = ({ className }: NewProjectCTABannerProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(className, 'bg-primary-mid px-[24px] py-[80px] flex flex-col items-center rounded-[4px]')}
    >
      <h2 className="text-center text-secondary-light my-[40px] mx-[auto] text-[32px] lg:text-[48px] leading-[32px] lg:leading-[48px] text-balance max-w-[524px]">
        {t('components.NewProjectCTABanner.text')}
      </h2>
      <Button
        style={ButtonStyle.PRIMARY_OUTLINED}
        className="grow-0 lg:px-[24px] lg:py-[20px]"
        tagSpecificProps={{
          htmlTag: ButtonHTMLTag.LINK,
          href: `${process.env.NEXT_PUBLIC_REDIRECT_URL}/${Routes.SUGGESTION}`,
        }}
      >
        {t('components.NewProjectCTABanner.button')}
      </Button>
    </div>
  );
};

export default NewProjectCTABanner;
